export type DocumentFormat = {
  label: string;
  value: string;
  ratio: number;
};

export const DOCUMENT_FORMATS: Record<string, DocumentFormat[]> = {
  CNI: [
    {
      label: "Nouveau format (carte bancaire)",
      value: "CNI_NOUVEAU",
      ratio: 85.6 / 53.98,
    },
    { label: "Ancien format", value: "CNI_ANCIEN", ratio: 105 / 74.5 },
  ],
  Passeport: [
    { label: "Format français", value: "PASSEPORT_FR", ratio: 125 / 88 },
    { label: "Format international", value: "PASSEPORT_INTL", ratio: 125 / 88 },
  ],
  "Format A4": [{ label: "A4 (standard)", value: "A4", ratio: 210 / 297 }],
  "Sécurité sociale": [
    { label: "Carte vitale", value: "VITALE", ratio: 85.6 / 54 },
  ],
};
